export function Switch({ on }: { on: boolean }) {
  return (
    <div className={`switch ${on ? 'is-on' : ''}`} aria-checked={on} role="switch">
      <div className="switch-knob" />
    </div>
  );
}

/**
 * Chip flotante "volver al final" del hilo: aparece cuando el user scrolleó
 * lejos del fondo (autoscroll respetuoso — el streaming no lo arrastra).
 * Sticky DENTRO del contenedor scrolleable de cada shell.
 */
export function JumpToLatestChip({ onJump }: { onJump: () => void }) {
  return (
    <button
      type="button"
      className="jump-latest"
      onClick={onJump}
      aria-label="Ir al final de la conversación"
    >
      <svg viewBox="0 0 12 12" width={11} height={11} aria-hidden="true">
        <path
          d="M6 2v7M2.8 5.8 6 9l3.2-3.2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>Volver al final</span>
    </button>
  );
}
